import React, { useState, useEffect } from "react";
import BackgroundVideo from '../../components/elements/BackgroundVideo';

export default function ZoneContent({ page, content, children, region }) {
    const [activeIndex, setActiveIndex] = useState(false);

    const handleShowMore = (e) => {
        const _id = activeIndex && activeIndex === e.target.dataset.rel ? -1 : e.target.dataset.rel;
       _id && setActiveIndex(_id);
    }

    // const video = region ? require(`../../assets/videos/${ region }.mp4`).default : null;
    const poster = region ? require(`../../assets/videos/${ region }_picture.jpg`).default : null;
    const video = region ? require(`../../assets/videos/${ region }.mp4`).default : null;
    const video_title =  'Paroles d\'habitants</span>'

    return (
        <div key={ activeIndex ? activeIndex : 'zonecontent' } id="zone__content" className={`container-fluid ${ region ? region : ''}`} >

            <div className="container-fluid pt-6">
                {
                page?.length > 0 && page[0]?.content &&
                    <div dangerouslySetInnerHTML= {{ __html: page[0]?.content?.rendered}} />
                }

                {
                children &&
                    <>
                        {
                            children?.length > 0 ?
                                children.map((item, index) => {
                                  const { id, title, textSuite, desc, media, credit } = item[0];

                                  return (
                                    <>

                                      <div className={`zone__content__elements my-6 ${activeIndex && parseInt(activeIndex) === parseInt(id) ? 'active' : "inactive"}`}>

                                            <div className={`columns is-multiline m-0 `}>
                                                <div className="column text is-5-widescreen is-12">
                                                    <h3 dangerouslySetInnerHTML={{ __html: title }} />

                                                    <div dangerouslySetInnerHTML = {{ __html: desc }} />
                                                    <div className="button">
                                                        <button
                                                            data-rel={id}
                                                            onClick={ e => {  handleShowMore(e) }}
                                                            className="btn"
                                                        >
                                                          {
                                                            !activeIndex || parseInt(activeIndex) !== parseInt(id) ? `En savoir +` : 'En savoir -'
                                                          }
                                                        </button>

                                                    </div>
                                                </div>
                                                <div className="column photo is-6-widescreen is-12">
                                                  {media && <img className="responsive-image" src={media} alt="" />}
                                                  {credit && <span className="credit">©{credit}</span>}
                                                </div>
                                                <div
                                                    className={`column content-add is-12 ${ textSuite && textSuite.length > 600 ? 'content-add-column' :''}` }
                                                    dangerouslySetInnerHTML = {{ __html: textSuite }}
                                                />
                                            </div>
                                        </div></>
                                    );
                                })
                                :
                                ''
                        }

                    </>
                }
        </div>
         <div id="zone__content__video" className="pt-6" >
              <div className="container-fluid">
                  <div className="columns is-multiline m-0">
                    <div className="column is-12 is-5-widescreen column1 has-text-centered is-flex is-flex-direction-column  is-justify-content-center">
                      <div>
                        <h3 dangerouslySetInnerHTML={{ __html: video_title }} />
                        <p>Extrait du film « <a href="https://soreqa.fr/10ans" target="_blank">Une nouvelle vi(ll)e</a> » réalisé par Alice Cagnat.</p>
                      </div>
                    </div>
                    <div className="column px-0 is-12 is-7-widescreen  column2" >
                {video ? <BackgroundVideo key={`video_${activeIndex}`} video={video} poster={poster} /> : ''}

                    </div>
                  </div>
              </div>
            </div>
        </div>
    )
}
